module.exports = __webpack_public_path__ + "static/media/microsoft-outlook-icon.2b540a7c.svg";